function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M400.632,206.215l-35.294-52.267c-2.383-3.526-5.626-6.388-9.436-8.301c0,0-79.31-42.956-93.348-45.304 c-17.478-2.924-27.268,3.309-38.299,7.938c-13.279,5.571-53.168,19.347-53.168,19.347l-40.303-34.15 c-10.506-8.892-26.215-7.595-35.1,2.902c-8.883,10.497-7.587,26.206,2.902,35.099l50.97,43.18 c4.572,3.867,10.295,5.901,16.099,5.901c2.627,0,5.269-0.413,7.83-1.264l29.445-9.755l-11.952,88.229 c-0.535,3.943-1.979,15.095,0.859,24.237l28.176,90.349l-22.583,85.89c-4.086,15.515,5.188,31.403,20.703,35.48 c2.48,0.656,4.96,0.964,7.408,0.964c12.889,0,24.658-8.633,28.079-21.675l24.707-93.956c1.394-5.269,1.265-10.83-0.356-16.034 l-14.223-45.609l32.315,14.458l-13.779,67.838c-3.194,15.726,6.954,31.062,22.68,34.256c1.962,0.397,3.907,0.591,5.82,0.591 c13.52,0,25.647-9.5,28.435-23.272l18.417-90.641c2.707-13.326-4.183-26.75-16.601-32.302l-50.622-22.648l12.338-91.073 l24.941,12.576l31.663,46.885c4.814,7.125,12.661,10.967,20.653,10.967c4.799,0,9.646-1.378,13.926-4.264 C405.333,233.087,408.332,217.612,400.632,206.215z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.778,94.986c25.939-5.649,42.361-31.241,36.721-57.155c-5.641-25.923-31.24-42.37-57.164-36.72 c-25.922,5.649-42.344,31.231-36.721,57.155C245.275,84.189,270.856,100.626,296.778,94.986z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg326(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.689 494.689",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg326);
export default __webpack_public_path__ + "static/media/3_26.1773d0be.svg";
export { ForwardRef as ReactComponent };